module.exports = __webpack_public_path__ + "img/open.25ef39c9.svg";